module.exports = __webpack_public_path__ + "01_medium_grey.8941104f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/01_medium_grey.png
// module id = cN8K
// module chunks = 0